import { t, tl, tx } from '../../i18n/t';
import { DOC_FOLDERS, type DocFolder } from '../../lib/ordner';
import type { KanzleiDocItem } from './types';

// Ordner unter „Dokumente“ (Reihenfolge wie auf der Seite): Briefe, die der Mandant selbst hochlädt, Steuerbescheide,
// die Ordner für Dokumente der Kanzlei (Vollmachten, Verträge …), BWA und Jahresabschluss. Briefe und Jahresabschluss
// haben eigene Seiten, die übrigen zeigt die Ordnerseite. Die Namen sind Deutsch, angezeigt werden sie mit t(f.label).
export type FolderKey = 'briefe' | 'steuerbescheide' | DocFolder | 'bwa' | 'jahresabschluss';

export const FOLDERS: { key: FolderKey; label: string; ico: string }[] = [
  { key: 'briefe', label: tl('Briefe'), ico: '✉' },
  { key: 'steuerbescheide', label: tl('Steuerbescheide'), ico: 'St' },
  ...DOC_FOLDERS.map(([key, label]) => ({ key, label, ico: label.slice(0, 2) })),
  { key: 'bwa', label: tl('BWA'), ico: 'BW' },
  { key: 'jahresabschluss', label: tl('Jahresabschluss'), ico: 'J' },
];

// Titel für die Anzeige: BWA und Jahresabschluss benennt der Server („BWA Oktober 2026“), die übrigen sind Titel der
// Kanzlei und bleiben, wie sie sind
export const itemTitle = (x: KanzleiDocItem) => (x.type === 'bwa' || x.type === 'jahresabschluss' ? tx(x.title) : x.title);

// „1 Dokument“ / „3 Dokumente“ (eigene Texte statt plural(): „Dokumente“ ist auch eine Überschrift)
export const docCount = (n: number) => (n === 1 ? t('1 Dokument') : t('{n} Dokumente', { n }));

export const folderOf = (x: KanzleiDocItem): FolderKey =>
  x.type === 'bescheid' ? 'steuerbescheide' : x.type === 'dokument' ? ((x.folder as DocFolder) ?? 'sonstiges') : x.type;

// Ordner der Ordnerseite (nicht Briefe und Jahresabschluss, die haben eigene Bereiche)
export const docsFolderOfSlug = (slug: string | undefined) =>
  FOLDERS.find((f) => f.key === slug && f.key !== 'briefe' && f.key !== 'jahresabschluss') ?? null;

// Pfade: /app/dokumente/<Firma>/<Ordner>; Briefe unter /app/dokumente/<Firma>/briefe/<Absender>
export function dokumentePath(clientId?: string, folder?: FolderKey): string {
  if (!clientId) return '/app/dokumente';
  return folder ? `/app/dokumente/${clientId}/${folder}` : `/app/dokumente/${clientId}`;
}
